import { string } from 'yup'

const emailField = message => string().email(message || 'Please enter a valid email')

export default emailField
